import axios, {AxiosResponse} from "axios";
import {ForgotPasswordResponse} from "./types";

export const forgotPasswordMutation = async (email: string): Promise<AxiosResponse<ForgotPasswordResponse>> => {
  const response = await axios.post('/api/auth/forgot-password/', {email}, {withCredentials: true})
  return response
}
